/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolSavingsIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-savings"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M6.2 21.32Q5.38 21.32 4.63 20.76Q3.88 20.2 3.65 19.4Q3.08 17.4 2.69 15.91Q2.3 14.43 2.06 13.26Q1.82 12.1 1.73 11.2Q1.63 10.3 1.63 9.5Q1.63 7.08 3.33 5.38Q5.03 3.67 7.45 3.67L12.3 3.67Q13.05 2.73 14.15 2.2Q15.25 1.68 16.45 1.68Q17.32 1.68 17.8 2.1Q18.27 2.52 18.27 3.3Q18.27 3.45 18.24 3.69Q18.2 3.92 18.15 4.1Q18.07 4.33 17.99 4.61Q17.9 4.9 17.85 5.13L19.9 7.17L21.05 7.17Q21.6 7.17 21.98 7.55Q22.35 7.92 22.35 8.47L22.35 13.75Q22.35 14.18 22.11 14.53Q21.88 14.88 21.45 15L19.4 15.65L18.27 19.43Q18 20.27 17.3 20.8Q16.6 21.32 15.72 21.32L14.35 21.32Q13.4 21.32 12.65 20.8Q11.9 20.27 11.7 19.32L11.7 19.32L10.25 19.32L10.25 19.32Q10.05 20.27 9.3 20.8Q8.55 21.32 7.6 21.32ZM15.63 11.32Q15.63 11.32 15.9 11.32Q16.18 11.32 16.56 10.94Q16.95 10.55 16.95 10Q16.95 9.45 16.56 9.06Q16.18 8.68 15.63 8.68Q15.07 8.68 14.69 9.06Q14.3 9.45 14.3 10Q14.3 10.55 14.69 10.94Q15.07 11.32 15.63 11.32ZM11.85 9.82Q12.38 9.82 12.74 9.46Q13.1 9.1 13.1 8.57Q13.1 8.05 12.74 7.69Q12.38 7.33 11.85 7.33L8.7 7.33Q8.18 7.33 7.81 7.69Q7.45 8.05 7.45 8.57Q7.45 9.1 7.81 9.46Q8.18 9.82 8.7 9.82Z" fill={color} />
    </svg>
  );
}
